module.exports = __webpack_public_path__ + "img/sharpspring.dd1fede3.png";